(() => {
  function initBrandFilter(root = document) {
    const input = root.querySelector('[data-tn-brand-search]');
    if (!input || input.dataset.ready) return;

    input.dataset.ready = 'true';
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let matches = 0;

      document.querySelectorAll('[data-tn-brand]').forEach((link) => {
        link.hidden = !link.dataset.tnBrand.toLowerCase().includes(query);
        if (!link.hidden) matches += 1;
      });

      const emptyMessage = document.querySelector('[data-tn-brand-empty]');
      if (emptyMessage) emptyMessage.hidden = matches > 0;
    });
  }

  function initMenus(root = document) {
    root.querySelectorAll('.tn-mobile-menu').forEach((menu) => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');

      const syncState = () => {
        summary.setAttribute('aria-expanded', String(menu.open));
        summary.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
        document.body.classList.toggle('tn-menu-open', Boolean(document.querySelector('.tn-mobile-menu[open]')));
      };

      menu.addEventListener('toggle', syncState);
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !menu.open) return;
        const focusable = [...menu.querySelectorAll('summary, a[href], button:not([disabled]), input:not([disabled])')]
          .filter((element) => !element.hidden && element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      syncState();
    });
  }

  function init(root = document) {
    initBrandFilter(root);
    initMenus(root);
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.tn-mega[open], .tn-mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tn-mega[open], .tn-mobile-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 749) {
      document.querySelectorAll('.tn-mobile-menu[open]').forEach((menu) => {
        menu.open = false;
      });
    }
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init();
})();
